import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from 'shared/config/env.config';
import { BaseHttpService } from 'shared/base/_base-http.service';
import {catchError} from 'rxjs/operators';

@Injectable()
export class PartNumberService extends BaseHttpService {

    fetch(brandId: string, partNumber: string): Observable<any> {
        return this.http.get(Config.API + '/part-numbers/' + brandId + '?partNumber=' + partNumber)

            .pipe(catchError(this.handleError.bind(this)));
    }

    search(brandId: string, search: string): Observable<any> {
        return this.http.get(Config.API + '/part-numbers/' + brandId + '?search=' + search)

            .pipe(catchError(this.handleError.bind(this)));
    }
}
